import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  total, // Alternative prop name
  totalItems, // Alternative prop name
  perPage, // Alternative prop name
  itemsPerPage, // Alternative prop name
  onPageChange,
  loading = false,
  className = ""
}) => {
  // Support both prop naming conventions
  const totalCount = total || totalItems || 0;
  const itemsPerPageCount = perPage || itemsPerPage || 10;

  if (totalPages <= 1) return null;

  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const handlePageClick = (page) => {
    if (page !== currentPage && !loading && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const pageNumbers = generatePageNumbers();
  // Calculate start and end items safely
  const startItem = totalCount > 0 ? (currentPage - 1) * itemsPerPageCount + 1 : 0;
  const endItem = totalCount > 0 ? Math.min(currentPage * itemsPerPageCount, totalCount) : 0;

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-between gap-4 ${className}`}>
      {/* Results info */}
      <div className="text-sm text-gray-700 dark:text-gray-300">
        {totalCount > 0 ? (
          <>Menampilkan {startItem} sampai {endItem} dari {totalCount} hasil</>
        ) : (
          <>Tidak ada hasil ditemukan</>
        )}
      </div>

      {/* Pagination controls */}
      <div className="flex items-center space-x-1">
        {/* Previous button */}
        <button
          onClick={() => handlePageClick(currentPage - 1)}
          disabled={currentPage === 1 || loading}
          className={`px-3 py-2 text-sm font-medium rounded-md border ${
            currentPage === 1 || loading
              ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed dark:bg-gray-800 dark:text-gray-600 dark:border-gray-700'
              : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
          } transition-colors`}
        >
          <i className="mgc_left_line text-base"></i>
        </button>

        {/* First page */}
        {pageNumbers[0] > 1 && (
          <>
            <button
              onClick={() => handlePageClick(1)}
              disabled={loading}
              className="px-3 py-2 text-sm font-medium rounded-md border bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600 transition-colors"
            >
              1
            </button>
            {pageNumbers[0] > 2 && (
              <span className="px-2 py-2 text-gray-500 dark:text-gray-400">...</span>
            )}
          </>
        )}

        {/* Page numbers */}
        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            disabled={loading}
            className={`px-3 py-2 text-sm font-medium rounded-md border transition-colors ${
              page === currentPage
                ? 'bg-primary text-white border-primary'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
            } ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            {page}
          </button>
        ))}

        {/* Last page */}
        {pageNumbers[pageNumbers.length - 1] < totalPages && (
          <>
            {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
              <span className="px-2 py-2 text-gray-500 dark:text-gray-400">...</span>
            )}
            <button
              onClick={() => handlePageClick(totalPages)}
              disabled={loading}
              className="px-3 py-2 text-sm font-medium rounded-md border bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600 transition-colors"
            >
              {totalPages}
            </button>
          </>
        )}

        {/* Next button */}
        <button
          onClick={() => handlePageClick(currentPage + 1)}
          disabled={currentPage === totalPages || loading}
          className={`px-3 py-2 text-sm font-medium rounded-md border ${
            currentPage === totalPages || loading
              ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed dark:bg-gray-800 dark:text-gray-600 dark:border-gray-700'
              : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
          } transition-colors`}
        >
          <i className="mgc_right_line text-base"></i>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
